function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomForestViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.975 17.55A4 4 0 006 18v3a4 4 0 007 2.646 3.998 3.998 0 01.975-6.096zM8 18a2 2 0 114 0v3a2 2 0 11-4 0v-3zM8.385 12.82h4.474a2.15 2.15 0 002.148-2.148c0-.993-.677-1.83-1.593-2.075A2.924 2.924 0 0010.819 7c-.882 0-1.696.394-2.242 1.057A2.388 2.388 0 006 10.434a2.388 2.388 0 002.385 2.386zm0-3.173c.093 0 .185.017.274.05.38.144.808-.02.994-.382a1.307 1.307 0 011.166-.716c.58 0 1.098.389 1.259.946a.8.8 0 00.768.577h.013a.55.55 0 110 1.1H8.385a.788.788 0 010-1.575z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.385 12.82h4.474a2.15 2.15 0 002.148-2.148c0-.993-.677-1.83-1.593-2.075A2.924 2.924 0 0010.819 7c-.882 0-1.696.394-2.242 1.057A2.388 2.388 0 006 10.434a2.388 2.388 0 002.385 2.386zm0-3.173c.093 0 .185.017.274.05.38.144.808-.02.994-.382a1.307 1.307 0 011.166-.716c.58 0 1.098.389 1.259.946a.8.8 0 00.768.577h.013a.55.55 0 110 1.1H8.385a.788.788 0 010-1.575z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 4H4v24h24V4zM4 2a2 2 0 00-2 2v24a2 2 0 002 2h24a2 2 0 002-2V4a2 2 0 00-2-2H4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 17v3a3 3 0 001.702 2.705A5.002 5.002 0 0111 21a5 5 0 018-4zm-6 4a3 3 0 116 0 3 3 0 01-6 0z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8a2 2 0 00-2 2v10a2 2 0 104 0V10a2 2 0 00-2-2zm-4 2a4 4 0 018 0v10a4 4 0 01-8 0V10z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 22h2v5h-2v-5zM15 24h2v3h-2v-3zM9 23h2v4H9v-4z",
    fill: props.color
  }));
}

export default SvgIconRoomForestViewFilled;